import { useSelector } from 'react-redux'


function useAuthorization(permissionCode) {
    const userData = useSelector((store) => store?.auth?.user?.result?.userData?.userPermission)
    return userData.includes(permissionCode) ? true : false
}

export default useAuthorization
